import { Injectable } from '@angular/core';
import { endpoints } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { BaseResult } from '../models/base.result.model';

@Injectable()
export class PixAccessService {
	private url = endpoints.pix;

	constructor(private http: HttpClient) { }

	getPixAccessAvailable(): Observable<BaseResult<boolean>> {
		return this.http.get<BaseResult<boolean>>(this.url.available);
	}
}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/pix-access/pix-access.service.ts